module.exports = __webpack_public_path__ + "img/rainbow-oval-0036a081945a9d57d4b8a8b4beed2ff7.png";